import { render } from "./BoardView.vue?vue&type=template&id=49cad4fd"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"

import "./BoardView.vue?vue&type=style&index=0&id=49cad4fd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__